import type { MetadataState } from '../../ParseCSVModal.js'
import type { CSVMappingResult } from '../../CSVModalTypes.js'
import { HabitatTypeConfig, LocalityTypeConfig } from '../ForEnums/MetadataEnumConfig.js'
import { HabitatTypes } from '../../../../../../Generated/HabitatType.js'
import type { LocalityTypeKey } from '../../../../../../Generated/LocalityType.js'

/**
 * Validate that habitate and location values refer correctly, since a habitat is assigned to a location type
 * @param state
 * @param csvResult
 * @constructor
 */

export function ValidateHabitatAndLocationAndTransform(
  state: MetadataState,
  csvResult: CSVMappingResult[],
): string[] {
  if (!state[HabitatTypeConfig.label] || !state[LocalityTypeConfig.label]) return []

  const ops: { index: number, localityType: LocalityTypeKey}[] = []
  let errorCount = 0
  csvResult.forEach((x, index) => {
    if (x.metadata.habitatType || x.metadata.localityType) {
      if (x.metadata.habitatType && x.metadata.localityType) {
        if (HabitatTypes[x.metadata.habitatType].locality !== x.metadata.localityType) {
          errorCount++
        }
      } else if (x.metadata.habitatType) {
        ops.push({ index: index, localityType: HabitatTypes[x.metadata.habitatType].locality })
      }
    }
  })

  if (errorCount == 0) {
    ops.forEach(x => {
      csvResult[x.index].metadata.localityType = x.localityType
    })
    return []
  } else {
    return [ `Found mismatching Habitat and Locality Types for ${errorCount} rows.` ]
  }
}